import React, { useMemo } from "react";
import { Box, Grid, Typography, Slider } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useCourse } from "../../../pages/course/hooks";
import { useQuiz, useQuizTimer } from "../../../pages/quiz/hooks";
import { addLeadingZero, formatTime } from "../../../utils";
import clockIcon from "../../../assets/images/quiz/clock.svg"

const useStyles = makeStyles()((theme) => ({
    root: {

    },
    title: {
        fontSize: '36px',
        fontWeight: 600,
    },
    subText: {
        fontSize: '18px',
        fontWeight: 400,
    },
    statsContainer: {
        display: 'flex',
        alignItems: 'center',
        height: '100%'
    },
    activeQuestion: {
        fontSize: '20px',
        fontWeight: 600,
        color: 'var(--mui-palette-primary-orange)'
    },
    questionNumber: {
        fontSize: '20px',
        fontWeight: 600,
        color: 'var(--mui-palette-primary-light)',
    },
    sliderRoot: {
        width: '100%', // Adjust as needed
        padding: '15px 0',
    },
    slider: {
        height: 8,
        color: '#e0e7ff', // Background color for the track
        '& .MuiSlider-thumb': {
            height: 34,
            width: 34,
            backgroundColor: '#3b82f6', // Color for the thumb
            border: '8px solid white',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            '&:hover, &.Mui-focusVisible': {
                boxShadow: '0px 0px 0px 8px rgba(59, 130, 246, 0.16)',
            },
            '&.Mui-active': {
                boxShadow: '0px 0px 0px 12px rgba(59, 130, 246, 0.16)',
            },
        },
        '& .MuiSlider-rail': {
            height: 8,
            opacity: 1,
            backgroundColor: '#e0e7ff', // Rail background color
        },
        '& .MuiSlider-track': {
            height: 8,
            borderRadius: 4,
            backgroundColor: '#3b82f6', // Track color #f3f4f6
        },
    },
    clockContainer: {
        display: 'flex',
        alignItems: 'center',
        color: '#fff', // White text color
    },
    clockIcon: {
        width: '50px', // Adjust the size of the clock image
        height: '50px',
        backgroundImage: `url(${clockIcon})`, // Add your clock image path here
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        zIndex: 1
    },
    timeText: {
        fontSize: '18px', // Adjust the size to match the large font
        marginLeft: theme.spacing(-2),
        borderRadius: '14px',
        backgroundColor: '#FF5722',
        padding: theme.spacing(2),
        fontWeight: 'bold',
        lineHeight: 0,
        width: '70px',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
        textAlign: 'center',
        textShadow: '0px 0px 2px rgba(0, 0, 0, 0.25)'
    },
}))

export const CourseHeader = () => {
    const { current, currentChapter, currentSession } = useCourse();
    const { currentQuestionNumber, quizDetails } = useQuiz();
    const { classes } = useStyles();
    const { timer, timerStarted, endTime, endedAt} = useQuizTimer();

    const percent = useMemo(() => Math.round(((currentQuestionNumber ? (currentQuestionNumber + 1) : 0) / (quizDetails?.noOfQuestions || 0)) * 100), [currentQuestionNumber, quizDetails])

    return (
        <Box sx={{ p: 1, bgcolor: 'var(--mui-palette-common-white)' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    {Object.keys(current).length > 0 && (
                        <Box>
                            <Typography variant="h3" className={classes.title}>
                                {current.courseName}
                            </Typography>
                            <Typography variant="div" className={classes.subText}>
                                {currentSession.name}
                            </Typography>
                        </Box>
                    )}
                </Grid>
                <Grid container item xs={12} md={8} justifyContent="space-between" alignItems="center">
                    <Grid item xs={8} style={{ paddingTop: 0 }}>
                        {!(endTime > 0 && endedAt) && currentChapter && currentChapter.chapterType && String(currentChapter.chapterType).toLowerCase() === 'assessment' && <div className={classes.statsContainer}>
                            <Slider
                                className={classes.slider}
                                classes={{ root: classes.sliderRoot }}
                                value={percent}
                                disabled
                            />
                            <Box sx={{ ml: 4 }}>
                                <span className={classes.activeQuestion}>{addLeadingZero(currentQuestionNumber + 1)}</span>
                                <span className={classes.questionNumber}>/{addLeadingZero(quizDetails.noOfQuestions)}</span>
                            </Box>
                        </div>}
                    </Grid>
                    {!(endTime > 0 && endedAt) && timerStarted && currentChapter && currentChapter.chapterType && String(currentChapter.chapterType).toLowerCase() === 'assessment' && <Box className={classes.clockContainer}>
                        <Box className={classes.clockIcon} />
                        <Typography className={classes.timeText}>{formatTime(timer)}</Typography>
                    </Box>}
                </Grid>
            </Grid>
        </Box>
    )
}